import { Stack } from "@fluentui/react";
import React from "react";
import { Media } from "../../../../Media/Media";
import { MediaProps } from "../../../../Media/Media.types";
import { ShimmerLine } from "../../../../Shimmer/ShimmerLine/ShimmerLine";
import { DrawerTitle, DrawerTitleProps } from "./DrawerHeaderTitle";
import { leftAlignmentStyles, mediaStyles, titleStyles } from "./DrawerHeaderTitle.styles";

export interface DrawerHeaderTitleWithShimmerProps {
    /**
     * Media component to render before the title
     */
    readonly media?: MediaProps;
    /**
     * Props for the title used in this column. Can be
     * Text HyperLink or NoHrefLink
     */
    readonly title: DrawerTitleProps;
    /**
     * Id to link with Drawer content
     */
    readonly id?: string;
}

export const DrawerHeaderTitleWithShimmer: React.FC<DrawerHeaderTitleWithShimmerProps> = ({
    media,
    title,
    id
}) => {

    return (
        <Stack horizontal={true} verticalAlign="center">
            {media && (
                <Stack styles={mediaStyles()} verticalAlign="center">
                    <Media {...media} />
                </Stack>
            )}
            <Stack styles={titleStyles()} verticalAlign="center">
                <Stack horizontal={true} horizontalAlign="start" styles={leftAlignmentStyles(title)}>
                    <DrawerTitle {...title} id={id} />
                </Stack>
                <Stack horizontal={true} horizontalAlign="start">
                    <ShimmerLine height={8} width={286} />
                </Stack>
            </Stack>
        </Stack>
    );
};
